import { useTasksStateContext } from "@vega-modules/context/TasksStateContext/context";
import { type Tile } from "@vega-modules/scenes/CoInvestmentsLP/components/Welcome/WelcomeStepsTiles";

import { WelcomeTasksPageV1 } from "./WelcomeTasksPageV1";
import { WelcomeTasksPageV2 } from "./WelcomeTasksPageV2";

type Props = {
  welcomeStepHeading?: string;
  welcomeStepTiles?: Tile[];
};

export const WelcomeTasksPage = ({
  welcomeStepHeading,
  welcomeStepTiles,
}: Props) => {
  const { version } = useTasksStateContext();

  if (version === "v2") {
    return <WelcomeTasksPageV2 />;
  }

  return (
    <WelcomeTasksPageV1
      welcomeStepHeading={welcomeStepHeading}
      welcomeStepTiles={welcomeStepTiles}
    />
  );
};
